<template>
  <div>
    <div v-if="!loading">
      <div v-for="asset in costs" :key="asset.asset">
        <h1>{{asset.name}} ({{asset.class}})</h1>
        <h2>Average price: {{formatPrice(asset.rate)}}</h2>
        <table>
          <tr>
            <th>From</th>
            <th>Till</th>
            <th>Days</th>
            <th>Quantity</th>
            <th colspan=2>Onetime</th>
            <th colspan=2>Transaction</th>
            <th colspan=2>Incidental</th>
            <th colspan=2>Expenses</th>
            <th colspan=2>Spread</th>
          </tr>
          <tr v-for="(cost, index) in asset.amounts" :key="index">
            <td>{{(new Date(cost.from)).toLocaleDateString()}}</td>
            <td>{{(new Date(cost.till)).toLocaleDateString()}}</td>
            <td>{{formatPrice((cost.till - cost.from) / 1000 / 60 / 60 / 24)}}</td>
            <td>{{formatPrice(cost.quantity)}}</td>
            <td>{{formatPrice(
              calcPrice(cost.cost.onetime, cost.from, cost.till, cost.quantity, asset.rate)
            )}}</td>
            <td>{{formatPrice(cost.cost.onetime, false, 3)}}%</td>
            <td>{{formatPrice(
              calcPrice(
                cost.cost.transaction * 100,
                cost.from,
                cost.till,
                cost.quantity,
                asset.rate
              )
            )}}</td>
            <td>{{formatPrice(cost.cost.transaction * 100, false, 3)}}%</td>
            <td>{{formatPrice(
              calcPrice(cost.cost.incidental, cost.from, cost.till, cost.quantity, asset.rate)
            )}}</td>
            <td>{{formatPrice(cost.cost.incidental, false, 3)}}%</td>
            <td>{{formatPrice(
              calcPrice(cost.cost.expenses, cost.from, cost.till, cost.quantity, asset.rate)
            )}}</td>
            <td>{{formatPrice(cost.cost.expenses, false, 3)}}%</td>
            <td v-if="index !== 0 && asset.class=='Opties'">{{formatPrice(
              Math.abs(cost.quantity-asset.amounts[index -1].quantity)
              * 2.5
            )}}</td>
            <td v-else-if="index !== 0">{{formatPrice(
              Math.abs(cost.quantity-asset.amounts[index -1].quantity)
              * cost.cost.spread
              * (cost.rate ? cost.rate : 0) / 100
            )}}</td>
            <td v-else>0,00</td>
            <td v-if="asset.class=='Opties'">&euro;2,50 p/s</td>
            <td v-else>{{formatPrice(cost.cost.spread, false, 3)}}%</td>
          </tr>
          <tr>
            <td colspan=4>Sub total</td>
            <td colspan=2>{{formatPrice(sumBy(
              asset.amounts,
              (cost) => calcPrice(
                cost.cost.onetime, cost.from,
                cost.till, cost.quantity, asset.rate
              )
            ))}}</td>
            <td colspan=2>{{formatPrice(sumBy(
              asset.amounts,
              (cost) => calcPrice(
                cost.cost.transaction * 100, cost.from,
                cost.till, cost.quantity, asset.rate
              )
            ))}}</td>
            <td colspan=2>{{formatPrice(sumBy(
              asset.amounts,
              (cost) => calcPrice(
                cost.cost.incidental, cost.from,
                cost.till, cost.quantity, asset.rate
              )
            ))}}</td>
            <td colspan=2>{{formatPrice(sumBy(
              asset.amounts,
              (cost) => calcPrice(
                cost.cost.expenses,
                cost.from,
                cost.till,
                cost.quantity,
                asset.rate
              )
            ))}}</td>
            <td colspan=2 v-if="asset.class=='Opties'">{{formatPrice(sumBy(
              asset.amounts,
              (cost) => cost.index > 0
                ? Math.abs(cost.quantity - asset.amounts[cost.index - 1].quantity)
                  * 2.5
                : 0
            ))}} (Handel: {{
            sumBy(
                asset.amounts,
                (cost) => cost.index > 0
                  ? Math.abs(cost.quantity - asset.amounts[cost.index - 1].quantity)
                  : 0
              )
            }})</td>
            <td colspan=2 v-else>{{formatPrice(sumBy(
              asset.amounts,
              (cost) => cost.index > 0
                ? Math.abs(cost.quantity - asset.amounts[cost.index - 1].quantity)
                  * cost.cost.spread
                  * (cost.rate ? cost.rate : 0) / 100
                : 0
            ))}} (Handel: {{
            sumBy(
                asset.amounts,
                (cost) => cost.index > 0
                  ? Math.abs(cost.quantity - asset.amounts[cost.index - 1].quantity)
                  : 0
              )
            }})</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-else key="loader" class="loader" />
  </div>
</template>

<script>
import { sumBy } from 'lodash-es';

export default {
  name: 'AdminUserCosts',
  data() {
    return {
      costs: [],
      loading: false,
    };
  },
  computed: {
    port() {
      return this.$store.state.currentPort;
    },
  },
  watch: {
    port() {
      this.getCosts();
    },
  },
  created() {
    this.getCosts();
  },
  methods: {
    sumBy,
    calcPrice(cost, from, till, quantity, rate) {
      const yearsControlled = (till - from) / 1000 / 60 / 60 / 24 / 365;
      return yearsControlled * (cost / 100) * quantity * rate;
    },
    getCosts() {
      this.loading = true;
      this.sdk.getAssetCostsPort(this.port, (response) => {
        if (response.status === 200) {
          // match costs
          const results = [];
          for (let i = 0; i < response.data.length; i += 1) {
            results.push({
              name: response.data[i].name,
              rate: response.data[i].rate,
              class: response.data[i].class,
              amounts: [],
            });
            let index = 0;
            for (let j = 0; j < response.data[i].amounts.length; j += 1) {
              let from = new Date(response.data[i].amounts[j].date);
              const till = response.data[i].amounts[j + 1]
                ? new Date(response.data[i].amounts[j + 1].date)
                : new Date();
              // eslint-disable-next-line
              const quantity = response.data[i].amounts[j].quantity;
              // eslint-disable-next-line
              const rate = response.data[i].amounts[j].rate;
              let cost = {
                onetime: 0,
                transaction: 0,
                incidental: 0,
                expenses: 0,
                spread: 0,
              };
              for (let k = 0; k < response.data[i].costs.length; k += 1) {
                if (
                  new Date(response.data[i].costs[k].date)
                  > from
                ) {
                  if (
                    till > new Date(response.data[i].costs[k].date)
                  ) {
                    results[i].amounts.push({
                      index,
                      from,
                      till: new Date(response.data[i].costs[k].date),
                      quantity,
                      cost,
                      rate,
                      extra: true,
                    });
                    index += 1;
                    from = new Date(response.data[i].costs[k].date);
                  } else {
                    break;
                  }
                }
                cost = response.data[i].costs[k];
              }
              results[i].amounts.push({
                index,
                from,
                till,
                quantity,
                cost,
                rate,
                extra: false,
              });
              index += 1;
            }
          }
          this.costs = results;
          this.loading = false;
        } else {
          this.loading = false;
          this.sdk.logout();
          window.location.reload();
        }
      }, '2023-1-1', '2023-12-31');
    },
  },
};
</script>
